import getId from './get-id';
import setId from './set-id';

export { getId, setId };
